import { Box, styled, Typography } from "@mui/material";

export const StyledModalBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 640,
  maxWidth: "calc(100vw - 32px)",
  maxHeight: "90vh",
  overflow: "auto",
  background: theme.palette.custom.white,
  borderRadius: theme.borderRadius.radius.large,
  outline: "none",
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.down("sm")]: {
    width: "calc(100vw - 24px)",
  },
}));

export const StyledModalHeader = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.primary,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "13px 20px",
  borderTopRightRadius: theme.borderRadius.radius.large,
  borderTopLeftRadius: theme.borderRadius.radius.large,
  flexShrink: 0,
}));

export const StyledModalTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  fontSize: theme.typography.large.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
}));

export const StyledModalBody = styled(Box)(() => ({
  padding: "20px 24px",
  flex: 1,
  overflow: "auto",
}));

export const StyledConfirmText = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.lockerValueColor,
  fontSize: theme.typography.base.fontSize,
  lineHeight: 1.5,
}));

export const StyledAddressSection = styled(Box)(({ theme }) => ({
  marginTop: 20,
  padding: "16px",
  borderRadius: theme.borderRadius.radius.wallet,
  border: "1px solid #e8eaed",
  background: "#f8fbff",
  minWidth: 0,
  overflow: "hidden",
}));

export const StyledAddressSectionHeader = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  marginBottom: 12,
}));

export const StyledAddressLabel = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeight.semiBold,
  fontSize: theme.typography.base.fontSize,
  color: theme.palette.custom.OrderTextColor,
}));

export const StyledAddressLine = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  color: theme.palette.custom.lockerValueColor,
  lineHeight: 1.5,
}));

export const StyledDefaultBadge = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  fontSize: theme.typography.mini.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  color: theme.palette.custom.primary,
  background: theme.palette.custom.white,
  border: `1px solid ${theme.palette.custom.primary}`,
  borderRadius: theme.borderRadius.radius.extraLarge,
  padding: "2px 10px",
  marginBottom: 8,
}));

export const StyledModalFooter = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  padding: "16px 24px 20px",
  flexShrink: 0,
  borderTop: "1px solid #eee",
}));

export const StyledEditLink = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.primary,
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline",
  },
}));
